import React from 'react';
import {
  DataGridGroup,
  useResponsiveParams,
  Paper,
  Text,
} from 'quanta-ui';

export default function VehicleDetails({ 
  vehicleDetailValues,
  lobCode,
  lobName,
  productCode,
  productName,
  quoteNumber
}) {
  let repeatForMobile = 2;
  let repeatForDesktop = 3;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  let screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });

  const data = [
    {
      grid_data: [
        {
          label: 'Make',
          text: vehicleDetailValues?.make?.value,
        },
        {
          label: 'Model',
          text: vehicleDetailValues?.model?.value,
        },
        {
          label: 'Variant',
          text: vehicleDetailValues?.variant?.variantName,
        },
        {
          label: 'Fuel Type',
          text: vehicleDetailValues?.fuelType,
        },
        {
          label: 'Seating Capacity',
          text: vehicleDetailValues?.seatingCapacity,
        },
        {
          label: 'Cubic Capacity',
          text: vehicleDetailValues?.cubeCapacity,
        },
        {
          label: 'Year of Manufacture',
          text: vehicleDetailValues?.yearOfManufacture,
          colSpan:
            screenType?.toString()?.toLowerCase() === 'mobile'
              ? repeat
              : 1,
        },
        {
          label: 'Date of Registration/Purchase',
          text: vehicleDetailValues?.dateOfReg,
          colSpan:
            screenType?.toString()?.toLowerCase() === 'mobile'
              ? repeat
              : 1,
        },
        {
          label: 'RTO Authority Code & Location',
          colSpan: repeat === repeatForMobile?repeat:1,
          text: `${vehicleDetailValues?.rtoAuthorityCode}${
            vehicleDetailValues?.rtoAuthorityCode &&
            vehicleDetailValues?.rtoLocationDesc
              ? '-'
              : ''
          }${vehicleDetailValues?.rtoLocationDesc}`,
        },
      ].filter((d) => d),
    },
  ];

  const other_props = {
    flow: 'cols',
    repeat,
    gapX: 0,
    gapY: 1,
    spaceY: 0,
    size: 'full',
    titleSeverity: 'info',
    textType: 'normal',
    useExpandablePaper: false,
    nullData: () => {
      return (
        <Text type="normal" severity="neutral">
          Not Captured
        </Text>
      );
    },
  };
  return (
    <Paper>
      <DataGridGroup {...{ data, ...other_props }} />
    </Paper>
  );
}







